import {
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  IconDefinition,
  faArrowsUpDownLeftRight,
} from "@fortawesome/pro-light-svg-icons";

export enum EventConstants {
  SHOW_KEYS_MAP = "SHOW-KEYS-MAP",
  HIDE_KEYS_MAP = "HIDE-KEYS-MAP",
  FMX_IMAGE_SELECTED = "FMX-IMAGE-SELECTED",
  FMX_IMAGE_UNSELECTED = "FMX-IMAGE-UNSELECTED",
  FMX_IMAGE_PROCEDURE_SELECTED = "FMX-IMAGE-PROCEDURE-SELECTED",
  FMX_SIDEBAR_PROCEDURE_SELECTED = "FMX-SIDEBAR-PROCEDURE-SELECTED",
  ADDITIONAL_IMAGE_SELECTED = "ADDITIONAL-IMAGE-SELECTED",
  FMX_HIGHLIGHT_SHOW = "highlight:show",
  FMX_HIGHLIGHT_HIDE = "highlight:hide",
  CANVAS_SHOW_COMMENTS = "CANVAS-SHOW-COMMENTS",
  ORTHO_SHOW_COMMENTS = "ORTHO-SHOW-COMMENTS",
  CANVAS_HIDE_COMMENTS = "CANVAS-HIDE-COMMENTS",
  ORTHO_HIDE_COMMENTS = "ORTHO-HIDE-COMMENTS",
  CANVAS_SHOW_NARRATIVES = "CANVAS-SHOW-NARRATIVES",
  ORTHO_SHOW_NARRATIVES = "ORTHO-SHOW-NARRATIVES",
  CANVAS_NARRATIVES_MODAL_STATE_CHANGED = "CANVAS-NARRATIVES-MODAL-STATE-CHANGED",
  ORTHO_NARRATIVES_MODAL_STATE_CHANGED = "ORTHO-NARRATIVES-MODAL-STATE-CHANGED",
  CANVAS_NARRATIVES_MODAL_CLOSED = "CANVAS-NARRATIVES-MODAL-CLOSED",
  CANVAS_TOGGLE_ANNOTATION_CATEGORY = "CANVAS-TOGGLE-ANNOTATION-CATEGORY",
  CANVAS_TOGGLE_ANNOTATION_POLYGON = "CANVAS-TOGGLE-ANNOTATION-POLYGON",
  CANVAS_ZOOM_INCREASE = "CANVAS_ZOOM-INCREASE",
  CANVAS_ZOOM_DECREASE = "CANVAS_ZOOM-DECREASE",
  CANVAS_CONTRAST_INCREASE = "CANVAS_CONTRAST-INCREASE",
  CANVAS_CONTRAST_DECREASE = "CANVAS_CONTRAST-DECREASE",
  CANVAS_BRIGHTNESS_INCREASE = "CANVAS_BRIGHTNESS-INCREASE",
  CANVAS_BRIGHTNESS_DECREASE = "CANVAS_BRIGHTNESS-DECREASE",
  CANVAS_IMAGE_RESET = "CANVAS-IMAGE_RESET",
  CANVAS_IMAGE_ROTATE = "CANVAS-IMAGE_ROTATE",
  CANVAS_IMAGE_FLIP = "CANVAS-IMAGE_FLIP",
  CANVAS_IMAGE_SELECTED = "CANVAS-IMAGE-SELECTED",
  CANVAS_PROCEDURE_SELECTED = "CANVAS-PROCEDURE-SELECTED",
  ORTHO_PROCEDURE_SELECTED = "ORTHO-PROCEDURE-SELECTED",
  CANVAS_PROCEDURE_SELECTED_FROM_PANEL = "CANVAS-PROCEDURE-SELECTED-FROM-PANEL",
  ORTHO_PROCEDURE_SELECTED_FROM_PANEL = "ORTHO-PROCEDURE-SELECTED-FROM-PANEL",
  CANVAS_NEXT_CLAIM_ALERT_STATUS = "CANVAS-NEXT-CLAIM-ALERT-STATUS",
  ORTHO_NEXT_CLAIM_ALERT_STATUS = "ORTHO-NEXT-CLAIM-ALERT-STATUS",
  CANVAS_GALLERY_CURSOR_RESET = "CANVAS-GALLERY-CURSOR-RESET",
  CANVAS_COMMENTS_RESET = "CANVAS-COMMENTS-RESET",
  ORTHO_COMMENTS_RESET = "ORTHO-COMMENTS-RESET",
  TRACK_SET_PROFILE = "TRACK-SET-PROFILE",
  TRACK_UNSET_PROFILE = "TRACK-UNSET-PROFILE",
  TRACK_ALL_SELECT_CLAIM = "TRACK-ALL-SELECT-CLAIM",
  TRACK_QUEUE_SELECT_CLAIM = "TRACK-QUEUE-SELECT-CLAIM",
  TRACK_CANVAS_CLAIM_INFORMATION = "TRACK-CANVAS-CLAIM-INFORMATION",
  TRACK_CANVAS_OPEN_PROCEDURE_DROPDOWN = "TRACK-CANVAS-OPEN-PROCEDURE-DROPDOWN",
  TRACK_ORTHO_OPEN_PROCEDURE_DROPDOWN = "TRACK-ORTHO-OPEN-PROCEDURE-DROPDOWN",
  TRACK_CANVAS_ACTIVE_PROCEDURE = "TRACK-CANVAS-ACTIVE-PROCEDURE",
  TRACK_CANVAS_SELECT_PROCEDURE_IMAGE = "TRACK-CANVAS-SELECT-PROCEDURE-IMAGE",
  TRACK_CANVAS_SELECT_ALL_ATTACHMENTS_IMAGE = "TRACK-CANVAS-SELECT-ALL-ATTACHMENTS-IMAGE",
  TRACK_CANVAS_SELECT_ONE_ANNOTATION = "TRACK-CANVAS-SELECT-ONE-ANNOTATION",
  TRACK_CANVAS_SELECT_ALL_ANNOTATIONS = "TRACK-CANVAS-SELECT-ALL-ANNOTATIONS",
  TRACK_CANVAS_SELECT_PROCEDURE_TABLE = "TRACK-CANVAS-SELECT-SERVICE-LINE",
  TRACK_ORTHO_SELECT_PROCEDURE_TABLE = "TRACK-ORTHO-SELECT-SERVICE-LINE",
  TRACK_CANVAS_START_COMMENT = "TRACK-CANVAS-START-COMMENT",
  TRACK_ORTHO_START_COMMENT = "TRACK-ORTHO-START-COMMENT",
  TRACK_CANVAS_VIEW_NARRATIVE = "TRACK-CANVAS-VIEW-NARRATIVE",
  TRACK_CANVAS_VIEW_HISTORY = "TRACK-CANVAS-VIEW-HISTORY",
  TRACK_ORTHO_VIEW_NARRATIVE = "TRACK-ORTHO-VIEW-NARRATIVE",
  TRACK_CANVAS_SHOW_KEYBOARD = "TRACK-CANVAS-TOGGLE-KEYS",
  TRACK_CANVAS_IMAGE_TOOLS = "TRACK-CANVAS-IMAGE-TOOLS",
  TRACK_CANVAS_NEXT_CLAIM = "TRACK-CANVAS-NEXT-CLAIM",
  TRACK_ORTHO_NEXT_CLAIM = "TRACK-ORTHO-NEXT-CLAIM",
  TRACK_CANVAS_PREVIOUS_CLAIM = "TRACK-CANVAS-PREVIOUS-CLAIM",
  TRACK_ORTHO_PREVIOUS_CLAIM = "TRACK-ORTHO-PREVIOUS-CLAIM",
  TRACK_CANVAS_EXIT_CLAIM = "TRACK-CANVAS-EXIT-CLAIM",
  TRACK_ORTHO_EXIT_CLAIM = "TRACK-ORTHO-EXIT-CLAIM",
  TRACK_CANVAS_REVIEW = "TRACK_CANVAS_REVIEW",
  TRACK_ORTHO_REVIEW = "TRACK_ORTHO_REVIEW",
}

export const CanvasKeys: Array<{
  name: string | Array<string | IconDefinition>;
  detail: string;
}> = [
  {
    name: "K",
    detail: "Toggle Keyboard Shortcuts",
  },
  {
    name: "N",
    detail: "View Narrative",
  },
  {
    name: "M",
    detail: "View Comments",
  },
  {
    name: "R",
    detail: "Reset Image Adjustments",
  },
  {
    name: "SPACE",
    detail: "Toggle Annotations",
  },
  {
    name: "P",
    detail: "View Periodontal Charting",
  },
  {
    name: ["SHIFT", faArrowsUpDownLeftRight],
    detail: "Move Image After Zooming",
  },
  {
    name: ["I", faArrowUp],
    detail: "Select the image above",
  },
  {
    name: ["I", faArrowDown],
    detail: "Select the image below",
  },
  {
    name: ["I", faArrowLeft],
    detail: "Select the image to the left",
  },
  {
    name: ["I", faArrowRight],
    detail: "Select the image to the right",
  },
  {
    name: ["Z", faArrowUp],
    detail: "Zoom In",
  },
  {
    name: ["Z", faArrowDown],
    detail: "Zoom Out",
  },
  {
    name: ["C", faArrowUp],
    detail: "Increase Contrast",
  },
  {
    name: ["C", faArrowDown],
    detail: "Decrease Contrast",
  },
  {
    name: ["B", faArrowUp],
    detail: "Increase Brightness",
  },
  {
    name: ["B", faArrowDown],
    detail: "Decrease Brightness",
  },
  {
    name: ["O", faArrowRight],
    detail: "Rotation Right",
  },
  {
    name: ["O", faArrowLeft],
    detail: "Rotation Left",
  },
  {
    name: ["H"],
    detail: "Flip Horizontal",
  },
  {
    name: ["V"],
    detail: "Flip Vertical",
  },
  {
    name: "ESC",
    detail: "Back",
  },
  {
    name: "TAB",
    detail: "Continue To Next Element",
  },
  {
    name: "ENTER",
    detail: "Submit Input",
  },
  {
    name: ["SHIFT", "L"],
    detail: "Log Out",
  },
];

export const FmxKeys: Array<{
  name: string | Array<string | IconDefinition>;
  detail: string;
}> = [
  {
    name: "K",
    detail: "Toggle Keyboard Shortcuts",
  },
  {
    name: "TAB",
    detail: "Continue To Next Element",
  },
  {
    name: "ENTER",
    detail: "Submit Input",
  },
  {
    name: "1-9",
    detail: "Jump To Procedure Line",
  },
  {
    name: ["SHIFT", "L"],
    detail: "Log Out",
  },
];

export enum KeyboardKeys {
  ALT = "alt",
  ARROW_DOWN = "ArrowDown",
  ARROW_LEFT = "ArrowLeft",
  ARROW_RIGHT = "ArrowRight",
  ARROW_UP = "ArrowUp",
  CHAR_B = "b",
  CHAR_C = "c",
  CHAR_H = "h",
  CHAR_I = "i",
  CHAR_K = "k",
  CHAR_L = "l",
  CHAR_M = "m",
  CHAR_N = "n",
  CHAR_P = "p",
  CHAR_O = "o",
  CHAR_R = "r",
  CHAR_V = "v",
  CHAR_Z = "z",
  CTRL = "ctrl",
  DOWN = "down",
  ENTER = "Enter",
  ESC = "Escape",
  LEFT = "left",
  NUM_NINE = "9",
  NUM_ONE = "1",
  RIGHT = "right",
  SHIFT = "shift",
  SPACE_BAR = "Space",
  TAB = "Tab",
  UP = "up",
}

export enum ToothNumberingSystem {
  UNIVERSAL = "universal",
  FDI = "fdi",
}

export const universalToFDIToothNumbers: Record<string, string> = {
  "1": "18",
  "2": "17",
  "3": "16",
  "4": "15",
  "5": "14",
  "6": "13",
  "7": "12",
  "8": "11",
  "9": "21",
  "10": "22",
  "11": "23",
  "12": "24",
  "13": "25",
  "14": "26",
  "15": "27",
  "16": "28",
  "17": "38",
  "18": "37",
  "19": "36",
  "20": "35",
  "21": "34",
  "22": "33",
  "23": "32",
  "24": "31",
  "25": "41",
  "26": "42",
  "27": "43",
  "28": "44",
  "29": "45",
  "30": "46",
  "31": "47",
  "32": "48",
};
